import { Configuration } from '../Api'

export function getAuthConfiguration() { return new Configuration({ apiKey: `Bearer ${localStorage.getItem('token')}`}); }